import { toast, ToastOptions } from 'react-toastify';

const defaultOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const showToast = {
  success: (message: string, options?: ToastOptions) => {
    toast.success(message, { ...defaultOptions, ...options });
  },

  error: (message: string, options?: ToastOptions) => {
    toast.error(message, { ...defaultOptions, ...options });
  },

  info: (message: string, options?: ToastOptions) => {
    toast.info(message, { ...defaultOptions, ...options });
  },

  warning: (message: string, options?: ToastOptions) => {
    toast.warning(message, { ...defaultOptions, ...options });
  },

  // Custom toast for lead operations
  leadCreated: () => {
    toast.success('Lead created successfully! 潛在客戶已成功建立！', defaultOptions);
  },

  leadUpdated: () => {
    toast.success('Lead updated successfully! 潛在客戶已成功更新！', defaultOptions);
  },

  leadDeleted: () => {
    toast.success('Lead deleted successfully! 潛在客戶已成功刪除！', defaultOptions);
  },

  leadConverted: () => {
    toast.success('Lead converted to customer! 潛在客戶已轉換為客戶！', defaultOptions);
  },

  activityAdded: () => {
    toast.success('Activity added! 活動已新增！', defaultOptions);
  },

  statusUpdated: () => {
    toast.success('Status updated! 狀態已更新！', defaultOptions);
  },

  priorityUpdated: () => {
    toast.success('Priority updated! 優先級已更新！', defaultOptions);
  },

  operationFailed: (error?: string) => {
    toast.error(
      error || 'Operation failed. Please try again. 操作失敗，請重試。',
      defaultOptions
    );
  },
};

export default showToast;
